import signInIM from './signInIM';
import type SkypeNotification from '../store/schema/ISkypeNotification';
import { getStore } from '../../store/chatStore';

export default function onUcwaNotification(notification: SkypeNotification) {
    switch (notification.type) {
        case 'UnreadMessage':
            if (!getStore().isChatCalloutShown && notification.sender && notification.sender.uri) {
                if (notification.sound) {
                    notification.sound.play();
                }
            }
            break;

        case 'SignInRequest':
            signInIM(true /*isUserExplicitSignIn*/);
            break;
    }
}
